import React, { useEffect, useState } from "react";
import Select from "../FormComponents/Select/Select";
import Input from "../FormComponents/Input/Input";
import Datepicker from "../../components/FormComponents/Datepicker/Datepicker";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { parseISO, format, addDays } from "date-fns";

const PackageTermQuote = (props) => {
	const { renewalData, renewalId, trackData } = props;
	const [policyStart, setPolicyStart] = useState(null);
	const [policyEnd, setPolicyEnd] = useState(null);
	const [drivers, setDrivers] = useState([]);
	const [cars, setCars] = useState([]);
	const [amount, setAmount] = useState([]);
	const [tracks, setTracks] = useState([]);
	const [period, setPeriod] = useState([]);
	const [deductible, setDeductible] = useState([]);

	const dispatch = useDispatch();

	useEffect(() => {
		if (renewalData) {
			let start = new Date(_.get(renewalData, "policy_start", new Date()));
			let end = new Date(
				_.get(
					renewalData,
					"policy_end",
					new Date().setFullYear(new Date().getFullYear() + 1)
				)
			);
			start.setDate(start.getDate() + 1);

			setPolicyStart(start);
			setPolicyEnd(end);
			setDrivers(renewalData.drivers);
			setCars(renewalData.cars);
			setAmount(renewalData.amount);
			setPeriod(renewalData.period);
			setDeductible(renewalData.fixed_deductible_percentage);
		}
	}, [renewalData]);

	useEffect(() => {
		if (trackData) {
			let thisTracks = JSON.parse(trackData);

			thisTracks = thisTracks.map((track) => (
				<option value={track[1]} key={track[1]}>
					{track[0]}
				</option>
			));
			setTracks(thisTracks);
		}
	}, [trackData]);

	const deductibleOptions = [
		<option value="5.0">5%</option>,
		<option value="10.0">10%</option>,
		<option value="15.0">15% override for all cars</option>,
	];

	const changeDeductible = (value) => {
		dispatch({
			type: "SET_LOADING_MONTHLY",
			payload: true,
		});
		const requestOptions = {
			method: "PUT",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ ...renewalData, deductible_percentage: value }),
		};
		fetch(`/api/v2/quotes/${renewalId}`, requestOptions)
			.then((response) => response.json())
			.then((data) => {
				dispatch({
					type: "SET_QUOTE_DATA",
					payload: data.quote,
				});
			});
	};

	const optionsTerm = [
		<option value="on_demand">Daily</option>,
		<option value="annual">Annual</option>,
	];

	const changePeriod = (value) => {
		dispatch({
			type: "SET_LOADING_MONTHLY",
			payload: true,
		});
		const requestOptions = {
			method: "PUT",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ ...renewalData, period: value }),
		};
		fetch(`/api/v2/quotes/${renewalId}`, requestOptions)
			.then((response) => response.json())
			.then((data) => {
				dispatch({
					type: "SET_QUOTE_DATA",
					payload: data.quote,
				});
			});
	};

	return (
		<>
			<div className="col ml-4 otmt-2">
				<h2>Package Term</h2>
			</div>
			<div className="d-flex flex-column justify-content-center">
				<div className="col-12">
					<div className="col-md-6 mt-3">
						<Select
							classSelect="form-control"
							label="DAILY / ANNUAL"
							classLabel="h5"
							options={optionsTerm}
							setVal={changePeriod}
							val={renewalData.period ? renewalData.period : false}
						/>
					</div>

					<div className="col-md-6 mt-3">
						<Select
							classSelect="form-control"
							label="Deductible"
							classLabel="h5"
							options={deductibleOptions}
							setVal={changeDeductible}
							val={renewalData.deductible_percentage ? renewalData.deductible_percentage : false}
						/>
					</div>
				</div>
				<div className="col-12">
					<div className="col-md-6 mt-3">
						<Datepicker
							label="POLICY START DATE"
							classLabel="h5"
							classInput="form-control text-left"
							val={policyStart}
							setVal={setPolicyStart}
							minDate={policyStart}
							maxDate={addDays(policyStart, 31)}
							name="startPolicy"
						/>
					</div>

					{period === "annual" && (
						<div className="col-md-6 mt-3">
							<Datepicker
								label="POLICY END DATE"
								classLabel="h5"
								classInput="form-control text-left"
								val={addDays(policyEnd, 1)}
								setVal={setPolicyEnd}
								minDate={policyStart}
								name="endPolicy"
							/>
						</div>
					)}

					{period === "on_demand" && (
						<div className="col-md-6 mt-3">
							<Select
								classSelect="form-control"
								label="TRACK"
								classLabel="h5"
								options={tracks}
							/>
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default PackageTermQuote;
